<template>
  <div class="im-card-message" :class="{ right: isMe }" @click="onTap">
    <div class="title-wrap">
      <span class="text">病历</span>
    </div>
    <div class="content-list">
      <div class="content-item">
        <div class="subtitle-head">
          <div class="subtitle">
            <span class="text">主诉</span>
          </div>
          <div class="subtitle-h3 txt">
            <span class="text">{{ messageContext.mainDiagnosis }}</span>
          </div>
        </div>
      </div>
      <div class="content-item">
        <div class="subtitle-head">
          <div class="subtitle">
            <span class="text">诊断</span>
          </div>
        </div>
        <div class="content">
          <div v-for="(txt, i) in messageContext.symptomName" :key="i" class="txt">
            <span class="text">
              【{{ filterHos(txt.symptomType, messageContext.visitRecordType) }}】{{
                txt.symptomName
              }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cardCb } from '../../utils/timInit'
export default {
  name: 'imCustomCase',
  props: {
    message: {
      type: Object,
      default() {
        return {
          payload: {}
        }
      }
    }
  },
  data() {
    return {
      // messageContext: {
      //   id: 13657,
      //   firstOrFollowVisit: '2',
      //   consciousState: '1',
      //   illnessState: '1',
      //   mainDiagnosis: '结肠癌化疗后半个月',
      //   medicalCurrentDesc: '半个月前再次化疗后，有乏力恶心症状，...',
      //   medicalHistoryDesc: '不详细',
      //   doctorAdvice: '',
      //   symptomName: [
      //     {
      //       symptomCode: 'C18.900',
      //       symptomName: '结肠恶性肿瘤',
      //       symptomType: '1'
      //     }
      //   ],
      //   familyHistoryDesc: '无',
      //   sensitiveHistoryDesc: '无',
      //   management: null,
      //   bodyExam: null,
      //   visitRecordType: '3',
      //   assistantExam: null,
      //   followVisitRecord: null
      // }
    }
  },
  computed: {
    isMe() {
      return this.message.flow === 'out'
    },
    messageContext() {
      const data = JSON.parse(this.message.payload.data)
      return data.content
    }
  },
  methods: {
    filterHos(val, type) {
      // return getKeyValueText('visit_record_type', val)
      const hash = {
        3: {
          // 蒙医
          3: '蒙医诊断',
          1: '西医诊断',
          2: '中医诊断'
        },
        2: {
          // 中医
          2: '中医诊断',
          4: '中医证型',
          1: '西医诊断'
        },
        1: {
          // 西医
          1: '西医诊断'
        },
        4: {
          // 蒙文
          3: '蒙医诊断',
          1: '西医诊断'
        }
      }

      return (hash[type] && hash[type][val]) || ''
    },
    onTap() {
      typeof cardCb === 'function' && cardCb(this.message)
    }
  }
}
</script>

<style lang="scss" scoped>
.im-card-message {
  border-radius: 0.597333rem;
  background: #ffffff;
  box-shadow: 0rem 0.128rem 0.426667rem 0rem #ebeff9;

  &.right {
    .title-wrap {
      border-radius: 0.597333rem 0 0 0;
    }
  }

  .title-wrap {
    padding: 0.384rem 0.512rem;
    font-size: 0.64rem;
    line-height: 0.853333rem;
    color: #ffffff;
    background: #0089ff;
    border-radius: 0 0.597333rem 0 0;
    text-align: left;

    & > .text {
      display: block;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }

  .content-list {
    padding: 0.256rem 0.512rem;

    .content-item {
      position: relative;
      padding-top: 0.256rem;
      padding-bottom: 0.256rem;
      border-bottom: 0.021333rem solid #ececec;

      // .subtitle-head {
      // }

      .subtitle {
        display: flex;
        align-items: center;
        padding-top: 0.256rem;
        padding-bottom: 0.256rem;
        padding-left: 0.213333rem;
        color: #222222;
        font-weight: 500;
        overflow: hidden;

        &::before {
          content: '';
          margin-right: 0.213333rem;
          display: block;
          width: 0.085333rem;
          height: 0.469333rem;
          border-radius: 0.053333rem;
          background: #0089ff;
        }

        & > .text {
          display: block;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }

      .subtitle-h3 {
        padding-left: 0.298667rem;
        padding-top: 0.256rem;
        padding-bottom: 0.256rem;
        display: flex;
        align-items: center;
        overflow: hidden;

        .h3 {
          margin-right: 0.32rem;
          display: block;
          flex: 2;
          font-size: 0.64rem;
          line-height: 0.64rem;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        .intro {
          flex: 1;
          font-size: 0.597333rem;
          line-height: 0.64rem;
          color: #888888;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        .text {
          color: #222222;
          font-weight: 400;
          font-family: PingFangSC-Regular, PingFang SC, Menksoft Budun;
        }
      }

      .content {
        padding-top: 0.256rem;
        font-size: 0.64rem;
        line-height: 0.938667rem;
        color: #222222;

        .txt {
          text-align: left;
          & > .text {
            font-weight: 400;
            font-family: PingFangSC-Regular, PingFang SC, Menksoft Budun;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }

      &:last-child {
        border-bottom: none;
      }
    }
  }
}
</style>
